import Navbar from './components/NavBar/Navbar.jsx';
import ModalPopupRecesso from './components/ModalPopupRecesso/ModalPopupRecesso.jsx';

function App() {
  return (
    <div className="container">
      { /*<ModalPopupRecesso />*/ }
      <Navbar/>      
    </div>
  );
}

export default App;
